import { createPortal } from "react-dom";
import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/** Shared bottom-right stack for copilot, staff chat, and other FABs. */
export function FloatingActionDock({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  if (typeof document === "undefined") return null;

  return createPortal(
    <div
      className={cn(
        "floating-action-dock fixed bottom-5 right-5 z-[90] flex flex-col-reverse items-end gap-3 overflow-visible",
        className,
      )}
      aria-label="Quick actions"
    >
      {children}
    </div>,
    document.body,
  );
}
